<template>
    <div id="contenedor" class="p-2 m-2">
      <TheFormContact />
    </div>
</template>


<style scoped>

  #contenedor {
    display: flex;
    flex-direction: row;
    justify-content: center;
    
  }


</style>